import { AdminRepository } from '~/src/repositories/Admin'
import { ContainerRepository } from '~/src/repositories/Container'
import { DashBoardRepository } from '~/src/repositories/DashBoard'
import { MeRepository } from '~/src/repositories/Me'
import { FavoritesRepository } from '~/src/repositories/Favorites'
import { FreightManagementRepository } from '~/src/repositories/FreightManagement'
import { FreightRepository } from '~/src/repositories/freight_repository'
import { InvoiceRepository } from '~/src/repositories/Invoice'
import { ListItemRepository } from '~/src/repositories/ListItem/ListItemRepository'
import { ListUserRepository } from '~/src/repositories/list_user_repository'
import { MemberRepository } from '~/src/repositories/MemberRepository/MemberRepository'
import { OrderRepository } from '~/src/repositories/Order'
import { OtherRepository } from '~/src/repositories/Other'
import { NotificationRepository } from '~/src/repositories/Notification'
import { RequestOrderRepository } from '~/src/repositories/RequestOrders'
import { SettingCurrencyRepository } from './SettingCurrency'
import { StatementAccountRepository } from '~/src/repositories/StatementAccount'
import { StatementRepository } from '~/src/repositories/StatementRepository'
import { StockRepository } from '~/src/repositories/Stock'
import { SupportHistoryRepository } from '~/src/repositories/SupportHistoryRepository'
import { UserRepository } from '~/src/repositories/User'
import { WishListRepository } from '~/src/repositories/WishList/WishListRepository'

export const adminRepository = new AdminRepository()
export const containerRepository = new ContainerRepository()
export const dashBoardRepository = new DashBoardRepository()
export const meRepository = new MeRepository()
export const favoritesRepository = new FavoritesRepository()
export const freightManagementRepository = new FreightManagementRepository()
export const freightRepository = new FreightRepository()
export const invoiceRepository = new InvoiceRepository()
export const listItemRepository = new ListItemRepository()
export const listUserRepository = new ListUserRepository()
export const memberRepository = new MemberRepository()
export const orderRepository = new OrderRepository()
export const otherRepository = new OtherRepository()
export const notificationRepository = new NotificationRepository()
export const requestOrderRepository = new RequestOrderRepository()
export const settingCurrencyRepository = new SettingCurrencyRepository()
export const statementAccountRepository = new StatementAccountRepository()
export const statementRepository = new StatementRepository()
export const stockRepository = new StockRepository()
export const supportHistoryRepository = new SupportHistoryRepository()
export const userRepository = new UserRepository()
export const wishListRepository = new WishListRepository()
